import { config } from '@/config/bzbsconfig.js'; // auto build use this
// import { config as configDev } from '@/config/bzbsconfig.dev.js';
import { config as configDev} from '@/config/bzbsconfig.dev.js';
import { config as configStg} from '@/config/bzbsconfig.stg.js';
import { config as configPrd} from '@/config/bzbsconfig.prd.js';

import { campaignConfig, dashboardConfig, categoryConfig, historyConfig, couponConfig } from './configlist.js';

export default function () {
    let appConfig = null;

    // configEnv json is set in index.html
    // convert string json to object
    let configEnvObj = JSON.parse(window.configEnv);
    switch (configEnvObj.build) {
        case 'dev':
            appConfig = configDev;
            break;
        case 'stg':
            appConfig = configStg;
            break;
        case 'prd':
            appConfig = configPrd;
            break;
        default:
            appConfig = config;
            break;
    }

    appConfig = Object.assign(appConfig, configEnvObj);

    appConfig.campaignConfig = campaignConfig;
    appConfig.dashboardConfig = dashboardConfig;
    appConfig.categoryConfig = categoryConfig;
    appConfig.historyConfig = historyConfig;
    appConfig.couponConfig = couponConfig;

    appConfig.setting = {
        cache: 'local',
        addressType: 'addressList', // profile, addressList
        encryptAccount: 'all', // none, token, all
    };

    return appConfig;
}
